<template>
    <div class="d-flex flex-column justify-content-center">
        <div class="w-100 pb-2">
            <label
                for="buttonType"
                class="font-14"
            >
                Tipo do Botão
            </label>

            <select
                name="buttonType"
                id="buttonType"
                class="form-control"
                v-model="item.frameContent.settings.type"
                @change="onChangeButtonType"
            >
                <option v-for="tp in buttonTypes" :key="tp.value" :value="tp.value">
                    {{ tp.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFrameButtonType',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            buttonTypes: {
                1: { name: "URL", value: 'url' },
                2: { name: "Whatsapp", value: 'whatsapp' }
            },
        }
    },
    methods: {
        onChangeButtonType() {
            this.$emit('onChangeButtonType', this.item)
        },
    },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameButtonType.vue